export const FETCH_FILTERS_BEGIN = 'FETCH_FILTERS_BEGIN';
export const FETCH_FILTERS_SUCCESS = 'FETCH_FILTERS_SUCCESS';
export const FETCH_FILTERS_ERROR = 'FETCH_FILTERS_ERROR';

export const SET_FILTER = 'SET_FILTER';
export const RESET_FILTERS = 'RESET_FILTERS';

export const FETCH_FILTERS = 'FETCH_FILTERS';

export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';

export const SET_PAGE = 'SET_PAGE';

export const PRODUCT_PRICES_LOADED = 'PRODUCT_PRICES_LOADED';

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCTS_LOADER = 'SET_PRODUCTS_LOADER';

export const SET_FILTERS_LOADER = 'SET_FILTERS_LOADER';
